export const costs = [
  'You learn pharmaceutical manufacturing from scattered SOPs, rushed trainings and audit findings that never show how the whole plant fits together',
  "You don't fully understand GMP, deviations, CAPA, cleanrooms or validation, so every missing signature, pressure alarm and auditor's question feels stressful",
  'Dosage forms, quality systems, contamination control, sterile processing and data integrity are never explained in one clear, visual place',
  'You lack the time to build a complete, coherent understanding of how medicines are made under GMP, from the warehouse to batch release',
];
